import { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import strings from '../../../../../common/Translation/Translate';
import axiosInstance from '../../../../../utils/axios';
import { routes } from '../../../../../utils/constants/routes';
import { URLS } from '../../../../../utils/constants/urls';
import { languages } from '../../../../../utils/redux/reducer/authentication-slice';
import AddEdit from '../../../CommonPage/AddEdit';
import { PaymentMethodForm } from './PaymentMethodForm';

const EditPaymentMethod: FC = () => {
  const { id } = useParams() as any;
  const languageList = useSelector(languages) as any;

  const [pageResponse, setPageResponse] = useState<any>([]);
  const [isLoading, setIsloading] = useState<boolean>(false);

  const getPaymentMethodResponse = useCallback(async () => {
    try {
      setIsloading(true);
      const { data } = await axiosInstance.get(URLS.getPaymentMethodsById(id));
      const container: any = {};
      for (let i = 0; i < languageList?.length; ++i) {
        let name = [`name_${languageList[i]?.value}`];
        container[name as any] = data.localizedAttributes[languageList[i]?.value]
          ? data.localizedAttributes[languageList[i]?.value].name
          : '';
      }
      setPageResponse({ ...data, ...container });
    } catch (error: any) {
    } finally {
      setIsloading(false);
    }
  }, [id, languageList]);

  useEffect(() => {
    (async () => {
      if (id) {
        await getPaymentMethodResponse();
      }
    })();
  }, [getPaymentMethodResponse, id]);

  const handleSetModel = useCallback(() => {
    const newArray = [...PaymentMethodForm(strings)];

    if (languageList && languageList.length > 0) {
      languageList.forEach((language: any) => {
        const nameObject = { ...PaymentMethodForm(strings)[1] };
        nameObject.field = `name_${language.value}`;
        nameObject.label = `${nameObject.label} (${language.text})`;
        newArray.push(nameObject);
      });
    }

    return newArray.filter((item: any) => item.field !== 'name');
  }, [languageList]);

  const pageConfig = {
    title: id ? strings.paymentMethod_title_edit : strings.paymentMethod_title_add,
    successMessage: id ? strings.common_update_message : strings.common_save_message,
    addEditApiUrl: URLS.getPaymentMethodsById(id),
    formModel: handleSetModel(),
    navigateToPage: routes.paymentMethods,
    isCustomResponse: true,
  };

  const handleCustomResponse = (custom: any) => {
    const localizedAttributes = [] as any;
    languageList !== undefined &&
      languageList?.map((item: { text: string; value: string }) =>
        localizedAttributes.push({
          language: item.value,
          name: custom[`name_${item.value}`],
        }),
      );
    return {
      code: custom.code,
      localizedAttributes: localizedAttributes,
    };
  };
  return (
    <AddEdit
      pageLoading={isLoading}
      pageConfig={pageConfig}
      pageResponse={pageResponse}
      handleCustomResponse={handleCustomResponse as any}
    />
  );
};
export default EditPaymentMethod;
